import React ,{useState ,useEffect} from 'react'
import ReactQuill from 'react-quill';
import {toast} from "react-toastify"
import { handleApi } from '../../utils/authentication';
import 'react-quill/dist/quill.snow.css';



const TermsAndConditions = () => {
    const [content, setContent] = useState('');
    const [loading,setLoading]=useState(false)

    const modules = {
      toolbar: [
        [{'header': [1, 2, 3, 4, 5, 6, false]}], // Header sizes
        [{'font': []}], // Font options
      
        ['bold', 'italic', 'underline'], // Text styles
        [{'list': 'ordered'}, {'list': 'bullet'}], // Lists
        ['link', 'image'], // Links and images
        [{'align': []}], // Text alignment
        ['clean'] // Remove formatting
      ],
    };
    
    const formats = [
      'header', 'font', 'bold', 'italic', 'underline',
      'list', 'bullet', 'link', 'image', 'align'
    ];
      

    const handleChange = (value) => {
      setContent(value);
    };
    const getTermsAndConditions=async ()=>{
        try {
            setLoading(true)  // Start loading
            const blob = new Blob([content], { type: 'text/plain;charset=utf-8' }); // Create a Blob from the content
       
            let method = "GET";
            let headers = {};
          
             let result = await handleApi('get_terms_and_conditions', method, headers,);
         
          //   console.log(result)
            if (result?.success) {
            //   toast.success('Terms and conditions updated Successfully.', {
            //     position: "top-right",
            //     autoClose: 5000,
            //     hideProgressBar: false,
            //     closeOnClick: true,
            //     pauseOnHover: true,
            //     draggable: true,
            //     progress: undefined,
            //     theme: "light",
            //   });
              setContent(result?.data?.content)
        
            } else {
              toast.error(result?.error?.error_message?result?.error?.error_message:"Something went wrong! Please Try again later", {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
              })
            }
          } catch (e) {
            toast.error(e.message, {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "light",
            })
          } finally {
            setLoading(false)  // Stop loading
          }

    }
    const saveTermsAndConditionsPage= async ()=>{
        try {
            setLoading(true)  // Start loading
            const blob = new Blob([content], { type: 'text/plain;charset=utf-8' }); // Create a Blob from the content
            const formData = new FormData(); // Create a FormData object
            formData.append('terms_and_conditions', blob, 'terms_and_conditions.html');
            let method = "POST";
            let headers = {};
          
             let result = await handleApi('edit_terms_and_conditions', method, headers, formData);
         
        
            if (result?.success) {
              toast.success('Terms and conditions updated Successfully.', {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
              });
             
         
              
      
        
        
            } else {
              toast.error(result?.error?.error_message?result?.error?.error_message:"Something went wrong! Please Try again later", {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
              })
            }
          } catch (e) {
            toast.error(e.message, {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "light",
            })
          } finally {
            setLoading(false)  // Stop loading
          }
     

    }

    useEffect(()=>{
        getTermsAndConditions()

    },[])
  

  return (
    <div className=''>
    <ReactQuill
        value={content}
        onChange={handleChange}
        modules={modules}
        formats={formats}
    />
    <div className='d-flex justify-content-end'>
        <button className='btn btn-outline-primary my-3' onClick={saveTermsAndConditionsPage}>Save</button>
    </div>
    {/* <div  dangerouslySetInnerHTML={{ __html: content }}/> */}


        
    </div>

      
   
  )
}

export default TermsAndConditions